import axios from 'axios';
import { endPoint } from '../utils/Utils';

export async function createPointBill(userId, shopId, orderNo) {
    const data = { "user_id": userId, "shop_id": shopId, "ref_id": orderNo };
    return axios.post(`${endPoint}/point/createPointBill`, data).then((response) => response.data);
}